"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormQuestionControllerRegistry = void 0;
const FormQuestionType_1 = __importDefault(require("../FormQuestionType"));
const QuestionControllerAsset_1 = __importDefault(require("./types/QuestionControllerAsset"));
const QuestionControllerCheck_1 = __importDefault(require("./types/QuestionControllerCheck"));
const QuestionControllerDateTime_1 = __importDefault(require("./types/QuestionControllerDateTime"));
const QuestionControllerInfo_1 = __importDefault(require("./types/QuestionControllerInfo"));
const QuestionControllerIssue_1 = __importDefault(require("./types/QuestionControllerIssue"));
const QuestionControllerList_1 = __importDefault(require("./types/QuestionControllerList"));
const QuestionControllerNumber_1 = __importDefault(require("./types/QuestionControllerNumber"));
const QuestionControllerPhoto_1 = __importDefault(require("./types/QuestionControllerPhoto"));
const QuestionControllerQuestionSet_1 = __importDefault(require("./types/QuestionControllerQuestionSet"));
const QuestionControllerRating_1 = __importDefault(require("./types/QuestionControllerRating"));
const QuestionControllerRepetition_1 = __importDefault(require("./types/QuestionControllerRepetition"));
const QuestionControllerSection_1 = __importDefault(require("./types/QuestionControllerSection"));
const QuestionControllerSignature_1 = __importDefault(require("./types/QuestionControllerSignature"));
const QuestionControllerSPT_1 = __importDefault(require("./types/QuestionControllerSPT"));
const QuestionControllerText_1 = __importDefault(require("./types/QuestionControllerText"));
exports.FormQuestionControllerRegistry = {
    [FormQuestionType_1.default.ASSET]: QuestionControllerAsset_1.default,
    [FormQuestionType_1.default.CHECK]: QuestionControllerCheck_1.default,
    [FormQuestionType_1.default.DATETIME]: QuestionControllerDateTime_1.default,
    [FormQuestionType_1.default.INFO]: QuestionControllerInfo_1.default,
    [FormQuestionType_1.default.ISSUE]: QuestionControllerIssue_1.default,
    [FormQuestionType_1.default.LIST]: QuestionControllerList_1.default,
    [FormQuestionType_1.default.NUMBER]: QuestionControllerNumber_1.default,
    // -----------------
    // PAUSE DEPRECATION
    //[FormQuestionType.PAUSE]: PauseQuestionController,
    // -----------------
    [FormQuestionType_1.default.PHOTO]: QuestionControllerPhoto_1.default,
    [FormQuestionType_1.default.RATING]: QuestionControllerRating_1.default,
    [FormQuestionType_1.default.REPETITION]: QuestionControllerRepetition_1.default,
    [FormQuestionType_1.default.SECTION]: QuestionControllerSection_1.default,
    [FormQuestionType_1.default.SIGNATURE]: QuestionControllerSignature_1.default,
    [FormQuestionType_1.default.SPT]: QuestionControllerSPT_1.default,
    [FormQuestionType_1.default.TEXT]: QuestionControllerText_1.default,
    [FormQuestionType_1.default.QUESTIONSET]: QuestionControllerQuestionSet_1.default,
};
exports.default = exports.FormQuestionControllerRegistry;
